import { GTagTriggerProps } from "./GTagTrigger.props";
import { GTagTriggerDiv } from "./GTagTrigger.styles";

export const GTagTrigger = ({ id }: GTagTriggerProps) => {
  return <GTagTriggerDiv id={id} />;
};
